export const GET_INBOX_SUCCESS = 'GET_INBOX_SUCCESS';
export const GET_INBOX_FAILURE = 'GET_INBOX_FAILURE';
export const GET_INBOX_REQUEST = 'GET_INBOX_REQUEST';

export const SAVE_FILTERS_INBOX = 'SAVE_FILTERS_INBOX';
export const CHANGE_PAGE_NO_INBOX = 'CHANGE_PAGE_NO_INBOX';
export const CHANGE_LIMIT_INBOX = 'CHANGE_LIMIT_INBOX';
export const MARK_AS_READ = 'MARK_AS_READ';
